export enum ModalType {
  Cancellation = 'CANCELLATION',
  CannotRescheduleGroup = 'CANNOT_RESCHEDULE_GROUP',
  Submission = 'SUBMISSION',
}

export enum CloseModalTriggers {
  CloseModal = 'keep-appointment',
  CancellationFeeModal = 'cancellation-fee-modal',
  Reschedule = 'reschedule',
}

export type ModalContext = {
  type: ModalType;
  props: any;
};
